import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <>
        <footer>
          <div className="" style={{ background: "#737070" }}>
            <div className="container">
              <div className="ft-widget-area footer_main_div">
                <div className="row">
                  <div class="col-md-3 col-sm-6">
                    <div className="ft-area1">
                      <div className="swin-widget swin-widget-about">
                        <div class="clerfix">
                          <div className="header-logo">
                            <img
                              src="./assets/images/logo/logo-nkp copy.jpg"
                              alt="deccan_cafe"
                              className="logo-img site_logo-footer footer_logo"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-9 footer-tab ">
                    <div className="row ">
                      <div className="col-md-12  d-md-flex">
                      <div className="col-md-6 col-sm-6 mb-3" style={{ paddingRight: "15px" }}>
                          <div className="ft-area1 ">
                            <div className="swin-widget widget-about">
                              <div className="title-widget footer_heading">
                              Employee Dining Enquiries{" "}
                              </div>
                              <div class="about-contact-info clearfix">
                                <div class="info-content phone-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-phone"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>(+91)-9289134415</p>
                                  </div>
                                </div>
                                <div class="info-content email-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-envelope"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>deccancafe.hyderabad@jpmorgan.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-6 mb-3" style={{ paddingRight: "15px" }}>
                          <div className="ft-area1">
                            <div className="swin-widget widget-about">
                              <div className="title-widget footer_heading">
                              Lobby Reception Enquiries{" "}
                              </div>
                              <div class="about-contact-info clearfix">
                                <div class="info-content phone-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-phone"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>
                                    +9140 – 68523747</p>
                                  </div>
                                </div>
                                <div class="info-content email-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-envelope"></i>
                                  </div>
                                  <div class="info-text ">
                                    <p>lobbyreception.hyderabad@jpmorgan.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="border-white" />

                    <div className="row">
                      <div className="col-md-12  d-md-flex">
                        <div class="col-md-6 col-sm-6">
                          <div className="ft-area1">
                            <div className="swin-widget widget-about">
                              <div className="title-widget footer_heading">
                              Conference Center Enquiries
                              </div>
                              <div class="about-contact-info clearfix">
                                <div class="info-content phone-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-phone"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>(+91)-9289134418</p>
                                  </div>
                                </div>
                                <div class="info-content email-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-envelope"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>
                                   conferencecentre.hyderabad@jpmorgan.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 col-sm-6">
                          <div className="ft-area1">
                            <div className="swin-widget widget-about">
                              <div className="title-widget footer_heading">
                                Pantry Services
                              </div>
                              <div class="about-contact-info clearfix">
                                <div class="info-content phone-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-phone"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>(+91)-9289134416</p>
                                  </div>
                                </div>
                                <div class="info-content email-content">
                                  <div class="info-icon">
                                    <i class="fa-icon fa fa-envelope"></i>
                                  </div>
                                  <div class="info-text">
                                    <p>
                                    deccancafe.hyderabad@jpmorgan.com</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
